export default "__VITE_ASSET__f9e9666f__"